// no-dd-sa:javascript-code-style/assignment-name,javascript-code-style/parameter-name
import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import _ from 'lodash';
import { getFormatter, groupKeys, isGroupKeyMatched, keysName } from '../../states/Utils';

export const TableChart = ({ view, data }) => {
  const formatter = getFormatter(view.config.format);
  const vertial_keys = groupKeys(data, view.config.vertical.keys);
  const horizontal_keys = groupKeys(data, view.config.horizontal.keys);
  const horizonal_formatter = getFormatter(view.config.horizontal.format);
  const header_row = horizontal_keys.map((k) => horizonal_formatter(keysName(data.meta, k)));
  const vertical_formatter = getFormatter(view.config.vertical.format);
  let computed = data.data.map((group) =>
    vertial_keys.map((vertical_key) => {
      let line = [vertical_formatter(keysName(data.meta, vertical_key))];
      let filtered = group.filter((d) => isGroupKeyMatched(d, vertical_key));
      return line.concat(horizontal_keys.map((horizontal_key) => formatter(_.sum(filtered.filter((d) => isGroupKeyMatched(d, horizontal_key)).map((d) => d.value)))));
    }),
  );

  const StyledTableRow = withStyles(TableRow, (theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
      fontFamily: 'courier, monospace',
    },
  }));

  const StyledTableCell = withStyles(TableCell, (theme) => ({
    head: {
      backgroundColor: '#444',
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }));
  return (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <StyledTableCell>{view.config.horizontal.legend}</StyledTableCell>
            {header_row.map((key) => (
              <StyledTableCell key={key}>{key}</StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {computed[0].map((row) => (
            <StyledTableRow key={row[0]}>
              {row.map((d) => (
                <TableCell>{d}</TableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
